import { actionCreator } from '@ardoq/rxbeach';
import { SidebarPanelContentIds } from './types';

export const openSidebarPanel = actionCreator<SidebarPanelContentIds>(
  '[SIDEBAR_PANEL] OPEN_SIDE_PANEL'
);

export const closeSidebarPanel = actionCreator(
  '[SIDEBAR_PANEL] CLOSE_SIDE_PANEL'
);

export const toggleSidebarPanel = actionCreator<SidebarPanelContentIds>(
  '[SIDEBAR_PANEL] TOGGLE_SIDE_PANEL'
);
